import { render, staticRenderFns } from "./HelpFormComponent.vue?vue&type=template&id=9658271e&"
import script from "./HelpFormComponent.vue?vue&type=script&lang=js&"
export * from "./HelpFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports